module.exports = __webpack_public_path__ + "img/calendar-lines.7cefe10d.svg";